import { HttpClient } from "@angular/common/http";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import * as moment from "moment";
import { Subject } from "rxjs";
import { EncryptionService } from "src/app/_services/encryption.service";
import { ExcelService } from "src/app/_services/excel.service";
import { MentorshipDashboardService } from "src/app/_services/mentorship-dashboard.service";

declare const $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-mentorship-hours-received",
  templateUrl: "./mentorship-hours-received.component.html",
})
export class MentorshipHoursReceivedComponent implements OnInit {
  @ViewChild("datePicker", { static: false }) datePicker: ElementRef;
  startDate: any;
  endDate: any;
  filterData = { status: "" };

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  // dtOptions: DataTables.Settings = {};
  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [{ targets: [6], orderable: false }],
  };
  dtTrigger = new Subject();
  mentorshipHoursReceivedArr: any = []; // Table Data list
  exportMeetingList: any = [];
  fieldsToIncludeExcel: any = [];
  exl: boolean = false;
  isSubmitted = false;
  dateInvalid: boolean = false;
  today: string = "";

  constructor(
    public router: Router,
    private http: HttpClient,
    private enc_dec: EncryptionService,
    private dataService: MentorshipDashboardService,
    private excelService: ExcelService
  ) {
    const now = new Date();
    this.today = now.toISOString().split("T")[0];
  }

  totalmentorshipHours: any;
  modalReference: NgbActiveModal;
  modalCropper: NgbActiveModal;

  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scroll(0, 0);
    const strtDate = sessionStorage.getItem("startDate");
    const endDate = sessionStorage.getItem("endDate");
    this.startDate = strtDate;
    this.endDate = endDate;

    this.getListing();
    this.meetingsListing();
  }

  setFilterData(e: any) {
    this.filterData.status = e.target.value;
    this.getListing();
    this.meetingsListing();

    const table = $("#hours_received").DataTable();
    table.search("").draw();
    table.ajax.reload(null, false);
  }

  getListing() {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        const data = {
          type: "total_mentorship_time",
          export: false,
          start_date: this.startDate,
          end_date: this.endDate,
          duration_filter: this.filterData.status,
        };

        const requestPayload = {
          ...dataTablesParameters,
          ...data,
        };

        const encryptedData = this.enc_dec.encrypt(
          JSON.stringify(requestPayload)
        );

        this.http
          .post<DataTablesResponse>(
            "/api/metric-list",
            { req_data: encryptedData },
            {}
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);
            this.mentorshipHoursReceivedArr = resp["data"];
            this.totalmentorshipHours = resp["recordsFiltered"];

            callback({
              recordsTotal: resp["recordsTotal"],
              recordsFiltered: resp["recordsFiltered"],
              data: [],
            });
          });
      },
      columns: [
        { data: "id" },
        { data: "meeting_id" },
        { data: "organizer_name" },
        { data: "invitee_name" },
        { data: "topic" },
        { data: "overlap_start" },
        { data: "overlap_end" },
        { data: "total_overlap_time" },
      ],
    };
  }

  onSearch() {
    this.isSubmitted = true;
    this.dateInvalid = false;

    if (!this.startDate || !this.endDate) {
      return;
    }

    const start = new Date(this.startDate);
    const end = new Date(this.endDate);

    if (start > end) {
      this.dateInvalid = true;
      return;
    }
    const table = $("#hours_received").DataTable();
    table.ajax.reload(null, false);
    this.meetingsListing();
  }

  meetingsListing() {
    const data = {
      start_date: this.startDate,
      end_date: this.endDate,
      export: true,
      type: "total_mentorship_time",
      duration_filter: this.filterData.status,
    };

    this.loadShow();
    this.dataService
      .dataExport(data)
      .pipe()
      .subscribe((res) => {
        this.exportMeetingList = res["data"];
        this.fieldsToIncludeExcel = [
          "meeting_id",
          "organizer_name",
          "invitee_name",
          "topic",
          "overlap_start",
          "overlap_end",
          "total_overlap_time",
        ];

        this.exl = true;

        this.loadHide();
      });
  }

  exportToExcel() {
    this.excelService.generateExcel(
      this.exportMeetingList,
      this.fieldsToIncludeExcel,
      "Mentorship Hours"
    );
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
    $("#hours_received").on("page.dt", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }

  ngOnDestroy(): void {
    $("#hours_received").off("page.dt");
    this.dtTrigger.unsubscribe();
  }

  blockTyping(event: KeyboardEvent) {
    event.preventDefault();
  }

  onReset() {
    this.isSubmitted = false;
    this.startDate = "";
    this.endDate = "";
    sessionStorage.removeItem("startDate");
    sessionStorage.removeItem("endDate");
    const table = $("#hours_received").DataTable();
    table.ajax.reload(null, false);
    this.meetingsListing();
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
}
